module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/empty-spot-700.a745b659052d65e3.png"+" 700w",
        images: [{path: "https://static.sniffspot.com/packs/img/empty-spot-700.a745b659052d65e3.png",width: 700,height: 500}],
        src: "https://static.sniffspot.com/packs/img/empty-spot-700.a745b659052d65e3.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/empty-spot-700.a745b659052d65e3.png"},
        
        width: 700,
        height: 500
      }